import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { Auth0Guard } from "@mrdm-self-service-frontend/shared/util-authorization";
import { PublicPagesGuard } from "./shared/services/public-pages-guard";

const routes: Routes = [
    {
        path: "",
        pathMatch: "full",
        canLoad: [PublicPagesGuard],
        canActivate: [PublicPagesGuard],
        loadChildren: () => import("./welcome/welcome.module").then(m => m.WelcomeModule)
    },
    {
        path: "register",
        // invite module is public except confirmation page (guards in InviteModule routing per page)
        loadChildren: () => import("./invite/invite.module").then(m => m.InviteModule)
    },
    {
        path: "create-account",
        canLoad: [PublicPagesGuard],
        canActivate: [PublicPagesGuard],
        loadChildren: () =>
            import("./create-account/create-account.module").then(m => m.CreateAccountModule)
    },
    {
        path: "logged-in",
        canLoad: [Auth0Guard],
        canActivate: [Auth0Guard],
        loadChildren: () => import("./logged-in/logged-in.module").then(m => m.LoggedInModule)
    },
    {
        path: "request",
        canLoad: [Auth0Guard],
        canActivate: [Auth0Guard],
        loadChildren: () => import("./request/request.module").then(m => m.RequestModule)
    },
    {
        // todo remove when email link update is deployed
        path: "validate/:code/email/:email",
        pathMatch: "full",
        redirectTo: "create-account/:code/email/:email"
    },
    {
        path: "**",
        pathMatch: "full",
        redirectTo: ""
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule {}
